import React, { createContext, useState, useContext } from 'react';

const DocumentsContextV2 = createContext();

export const DocumentsProviderV2 = ({ children }) => {
  const [documents, setDocuments] = useState([]);

  const updateDocument = (updatedDoc) => {
    setDocuments((prevDocs) =>
      prevDocs.map((doc) =>
        doc.id === updatedDoc.id ? { ...doc, ...updatedDoc } : doc
      )
    );
  };

  return (
    <DocumentsContextV2.Provider value={{ documents, updateDocument }}>
      {children}
    </DocumentsContextV2.Provider>
  );
};

export const useDocumentsV2 = () => useContext(DocumentsContextV2);

